import { Box, Divider, Grid, Typography } from "@mui/material";
import ViewCad from "../../../view";
import { FuncionarioViewProps } from "../funcionario.controll";
import { Funcionario } from "../funcionario.model";
import { ContentForm } from "../../../components/viewCadastro/formCad";

interface FuncionarioCadastroProps extends FuncionarioViewProps {
    handleCloseView: () => any
}

export function FuncionarioCadastro(props: FuncionarioCadastroProps) {
    const { funcionarioActions, funcionarioState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = funcionarioState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = funcionarioActions

    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: Funcionario) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Funcionario) => {
        const errors: any = {}
        if (!values.nome)
            errors.nome = "Informe o nome do funcionarioecedor"
        return errors
    }

    const handleUpdate = (value: Funcionario) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    var viewCad = new ViewCad({
        formTitle: "Cadastro do Funcionario",
        formFieldDescription: "nome",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar novo funcionario",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        contentForm: [
            { fieldName: "nome", label: "Nome", type: "text", key: "nome", colunsXS: 12, colunsSM: 6, colunsMD: 4, require: true },
            { fieldName: "sobrenome", label: "Sobrenome", type: "text", key: "nome", colunsXS: 12, colunsSM: 6, colunsMD: 4, require: true },
            { fieldName: "apelido", label: "Apelido", type: "text", key: "apelido", colunsXS: 12, colunsSM: 12, colunsMD: 4, require: false, },
            { fieldName: "tipo_doc", label: "", type: "radio", key: "tipo_doc", colunsXS: 12, colunsSM: 5, colunsMD: 5, require: true, radioDefaultValue: "CPF", radioOptionsValues: [{ label: "CNPJ", value: "CNPJ" }, { label: "CPF", value: "CPF" }] },
            { fieldName: "n_doc", label: "N° Documento", type: "text", key: "n_doc", colunsXS: 12, colunsSM: 7, colunsMD: 7, require: false },
            { fieldName: "whatsapp", label: "Whatsapp", type: "text", maskInputText: "99 9 9999-9999", key: "whatsapp", colunsXS: 12, colunsSM: 6, colunsMD: 4, require: true },
            { fieldName: "fone", label: "Fone", type: "text", key: "fone", colunsXS: 12, colunsSM: 6, colunsMD: 4 },
            { fieldName: "email", label: "Email", type: "text", key: "email", colunsXS: 12, colunsSM: 6, colunsMD: 4 },
            { fieldName: "admissao", label: "Data admissão", type: "data", key: "admissao", colunsXS: 12, colunsSM: 4, colunsMD: 4, require:false },
            { fieldName: "demissao", label: "Data demissão", type: "data", key: "demissao", colunsXS: 12, colunsSM: 4, colunsMD: 4, require:false },
            { fieldName: "ativo", label: "Ativo?", type: "checkbox", key: "ativo", colunsXS: 12, colunsSM: 4, colunsMD: 4,  },
        ],
        ContentBox:(props:any)=>{
            return (
                <Box flex={1} display={"flex"} flexDirection={"column"}>
                    <Typography variant="body1">Permissões</Typography>
                    <Divider/>
                    <Grid container spacing={2}>
                        <ContentForm fieldName={"rules.alterar_preco_item_venda"} type="checkbox" label="Alterar Preço do item na venda" colunsXS={12} colunsSM={12} colunsMD={12} />
                    </Grid>
                </Box>
            )
        }
    })

    return viewCad
}



